import Popover from "antd/lib/popover";
import "antd/lib/popover/style/css";

export default Popover;
